import { generatePath, Link as RouterLink, useLocation, useMatches } from 'react-router-dom';

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Text } from '@chakra-ui/react';

import { companyPaths } from 'app/constants/routes';

import { useManagingCompanyStore } from 'app/store';

import { ChevronRightOutline } from '@aslanpay/portal-common-lib';

import { MatchDataType, MatchHandleProps } from './types';

function CustomBreadcrumb() {
  const { company } = useManagingCompanyStore.getState();

  const matches = useMatches();

  const location = useLocation();

  const crumbs = matches
    .filter((match) => Boolean((match.handle as MatchHandleProps)?.crumb))
    .map((match, index) => {
      // NOTE: This logic is needed for now since we removed the navigation to Homepage
      // We need to identify the home crumbs to have the link to Employees page
      // We also need to disabled the "Employees" crumb since it will be the same as clicking on company crumb
      // We also need to disabled the Company crumb when we are the Employes page, because it will do nothing
      const isCompanyHome = company
        ? match.pathname ===
          generatePath(companyPaths.home.path, {
            companyId: useManagingCompanyStore.getState().company?.id,
          })
        : false;

      const path = isCompanyHome ? `${match.pathname}/employees` : match.pathname;

      const name = (match.handle as MatchHandleProps).crumb(match.data as MatchDataType);

      return {
        index,
        path,
        params: match.params,
        name,
        disabled:
          (name === 'Employees' && !location.pathname.startsWith('/employees')) ||
          path === location.pathname,
      };
    });

  return (
    <Breadcrumb
      display="flex"
      width="full"
      spacing="5px"
      separator={<ChevronRightOutline color="brand.darkGray" boxSize="10px" />}
      textStyle="smallMedium"
      color="brand.purple"
      overflow="hidden"
      listProps={{ overflow: 'hidden' }}
    >
      {crumbs.length > 1 &&
        crumbs.map((crumb, index) => {
          return (
            <BreadcrumbItem key={crumb.index} overflow="hidden">
              {!crumb.disabled && index !== crumbs.length - 1 ? (
                <BreadcrumbLink
                  as={RouterLink}
                  to={crumb.path}
                  py="5px"
                  px="10px"
                  borderRadius="5px"
                  isTruncated
                  _hover={{ bgColor: 'brand.lightGray2' }}
                >
                  {crumb.name}
                </BreadcrumbLink>
              ) : (
                <Text py="5px" px="10px" textStyle="smallMedium" color="brand.darkGray" isTruncated>
                  {crumb.name}
                </Text>
              )}
            </BreadcrumbItem>
          );
        })}
    </Breadcrumb>
  );
}

export default CustomBreadcrumb;
